import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "bg-fff p-l-r-10" }
const _hoisted_2 = { style: {"position":"relative"} }
const _hoisted_3 = { style: {"position":"absolute","right":"10px","z-index":"10"} }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Download")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Extend All")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Search")
const _hoisted_7 = { class: "bg-fff m-10 p-10" }
const _hoisted_8 = { class: "bg-fff m-10 p-10" }
const _hoisted_9 = { style: {"margin":"10px 0"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Breadcrumb, { dataSource: [{name: 'Calculator Version'}] }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_a_button, {
            class: "m-r-8",
            onClick: _ctx.handleDownload
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_a_button, {
            class: "m-r-8",
            onClick: _ctx.handleExtendAll
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_a_button, {
            class: "f-r",
            disabled: !_ctx.selectedRowKeys || _ctx.selectedRowKeys.length === 0,
            type: !_ctx.selectedRowKeys || _ctx.selectedRowKeys.length === 0 ? '' : 'primary',
            onClick: _ctx.handleSearch
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }, 8, ["disabled", "type", "onClick"])
        ])
      ]),
      _createVNode(_component_a_tabs, {
        activeKey: _ctx.activeKey,
        "onUpdate:activeKey": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeKey) = $event)),
        onChange: _ctx.cutTabs
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sheetArr, (sheet) => {
            return (_openBlock(), _createBlock(_component_a_tab_pane, {
              key: sheet,
              tab: sheet
            }, null, 8, ["tab"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["activeKey", "onChange"])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_a_table, {
        columns: _ctx.columns,
        pagination: false,
        "row-selection": { selectedRowKeys: _ctx.selectedRowKeys, onChange: _ctx.onSelectChange },
        "data-source": _ctx.dataSource,
        rowKey: (data) => data.programVersion,
        class: "clearfix",
        rowClassName: (record, index) => (index % 2 === 1 ? 'table-striped' : null)
      }, {
        timestemp: _withCtx(({text}) => [
          _createTextVNode(_toDisplayString(_ctx.moment(text).format('YYYY-MM-DD HH:mm:ss')), 1)
        ]),
        _: 1
      }, 8, ["columns", "row-selection", "data-source", "rowKey", "rowClassName"])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.verCompareList, (ver, index) => {
      return (_openBlock(), _createElementBlock("div", { key: index }, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("p", _hoisted_9, "Version " + _toDisplayString(ver.version) + " " + _toDisplayString(ver.version === ver.currentVersion ? '(Current)' : ''), 1),
          _createVNode(_component_a_table, {
            columns: _ctx.columnsVersion,
            pagination: false,
            scroll: {x: 800},
            "data-source": ver[_ctx.versionKey[_ctx.activeKey]],
            rowKey: (data,rowIndex) => rowIndex,
            class: "clearfix self-table-text",
            rowClassName: (record, index) => (index % 2 === 1 ? 'table-striped' : null)
          }, {
            showText: _withCtx(({text}) => [
              text
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: _normalizeClass({'color-r2 unlink-style': text.includes('@')})
                  }, _toDisplayString(text.includes('@')? text.substring(0, text.indexOf('@')) : text), 3))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1032, ["columns", "data-source", "rowKey", "rowClassName"])
        ])
      ]))
    }), 128))
  ]))
}